import { isFollowUpDueByEndOfToday } from "@/features/contact/helpers/follow-up";
import {
  CONVERSATION_STATUS,
  CONVERSATION_VIEW,
  ConversationStatus,
  ConversationView,
} from "@/types/conversation";

/**
 * Returns true when a contact should be hidden from the default working view
 * because it has a future-dated follow-up that isn't due yet AND the contact
 * hasn't sent an inbound message that would un-park it.
 *
 * Only applies when view is "all"/absent AND status is "open". Any other
 * view/status combination is NOT parked (returns false).
 */
export const isParkedFromDefaultView = (
  contact: {
    followUp?: { dueAt: string } | null;
    lastMessageOwner?: string | null;
  },
  view: ConversationView | string | undefined,
  status: ConversationStatus | string | undefined,
): boolean => {
  const isDefaultView = !view || view === CONVERSATION_VIEW.ALL;
  if (!(isDefaultView && status === CONVERSATION_STATUS.OPEN)) return false;
  return (
    Boolean(contact.followUp) &&
    !isFollowUpDueByEndOfToday(contact.followUp!.dueAt) &&
    contact.lastMessageOwner !== "contact"
  );
};
